import React from 'react';
import { connect } from 'react-redux';

import { getClass } from '../../../utils/component-helpers';
import { snakeCase } from '../../base/common/utils';
import { setSnackbar } from 'redux/actions';

const AlgorithmDistributions = (
	{
		distributions,
		distributionStatus,
		editDisabled,
		updateDistribution,
		type,
		isOverride=false,
		setSnackbar,
	}
) => {
	const displayMsgs = {
		invalid: 'Sum of distributions must equal 1.',
		saved: 'Distributions saved successfully.',
		noPublisher: 'A publisher must be selected.',
		removed: 'Successfully removed publisher override.',
	};

	const getDisplayMsg = () => {
		const statusKeys = ['invalid', 'saved', 'noPublisher', 'removed'];
		for (let i = 0; i < statusKeys.length; i++) {
			const status = statusKeys[i];
			if (distributionStatus[status]) {
				setSnackbar(displayMsgs[status]);
				return displayMsgs[status];
			}
		}

		return null;
	};

	const displayMsg = getDisplayMsg();

	const algorithmDistributions = distributions ? distributions.map((algorithm, index) => {
		const algorithmKey = algorithm.algorithm_name;
		// Add space before capital letter
		const algorithmName = algorithmKey.replace(/([A-Z])/g, ' $1');
		return (
			<div key={algorithmName}
				 className={getClass('info-box', {
					'invalid': displayMsg === displayMsgs.invalid,
				 })}>
				<p className="algorithm-name">{algorithmName}</p>
				<input
					type="text"
					value={algorithm.distribution_fraction}
					onChange={(event) => {
						updateDistribution(event.target.value, index, isOverride);
					}}
					disabled={editDisabled}
					className={`algorithm-distributions ${snakeCase(algorithmKey)}`}
				/>
			</div>
		);
	}) : null;

	return (
		<div className="algorithm-distributions-container">
			{algorithmDistributions}
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setSnackbar: (msg) => dispatch(setSnackbar(msg)),
	};
};

export default connect(null, mapDispatchToProps)(AlgorithmDistributions);
